import { render } from "./TwoLeaves.vue?vue&type=template&id=406e87fe&scoped=true"
import script from "./TwoLeaves.vue?vue&type=script&lang=js"
export * from "./TwoLeaves.vue?vue&type=script&lang=js"

import "./TwoLeaves.vue?vue&type=style&index=0&id=406e87fe&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406e87fe"]])

export default __exports__